<svelte:options
	customElement={{
		tag: 'rf-parallax-debug',
		shadow: 'open',
	}}
/>

<script module>
	type ReframeParallaxDebugProps = {
		coordinates: Map<number, { center: number; start: number; end: number }>;
	};
</script>

<script lang="ts">
	import classNames from 'classnames';
	import cssVariables from '@src/utils/cssvariables';
	let { coordinates = new Map<number, { center: number; start: number; end: number }>() }: ReframeParallaxDebugProps = $props();
</script>

{#each coordinates as [i, coords]}
	{#each Object.keys(coords) as key}
		<div
			class={classNames('parallax-debug--limit', `parallax-debug--limit__${key}`)}
			style={cssVariables({
				'--limit-value': (coords as { [key: string]: number })[key].toString(),
			})}
		>
			<span>{key} {i + 1}</span>
		</div>
	{/each}
{/each}

<style lang="scss" global>
	.parallax-debug {
		&--limit {
			position: absolute;
			top: calc(var(--limit-value) * var(--total-height) * 1px);
			left: 0;
			width: 100%;
			height: 2px;
			z-index: 10000;
			.horizontal & {
				top: 0;
				left: calc(var(--limit-value) * var(--total-height) * 1px);
				height: 100vh;
				width: 2px;
			}
			span {
				color: white;
				padding: 0 5px;
			}

			&__start {
				background: purple;
				span {
					background: purple;
				}
			}
			&__center {
				background: red;
				span {
					background: red;
				}
			}
			&__end {
				background: orange;
				span {
					background: orange;
				}
			}
		}
	}
</style>
